// ** Auth Endpoints
import endpointsConfig from "../../configs/endpointsConfig"


export default {
  loginEndpoint: `${endpointsConfig.backendUrl}Login/login`,
  refreshEndpoint: `${endpointsConfig.backendUrl}Login/refreshToken`
}
